// extracted by mini-css-extract-plugin
module.exports = {"face":"style_face__GBatk","face1":"style_face1__3z2np","face2":"style_face2__3hz4R","face3":"style_face3__1RRlW","face4":"style_face4__w0ufO","face5":"style_face5__3X_Ci"};